module.exports = __webpack_public_path__ + "img/mannul_home_add.f35c057a.png";